<template>
  <v-navigation-drawer
    v-model="miscDrawer"
    :clipped="true"
    :temporary="true"
    right
    app
    width="300"
    overlay-color="var(--ds-color-reverse)"
  >
    <h3 class="pa-5 pb-1">
      {{ listTitle }}
    </h3>
    <v-list
      dense
    >
      <draggable
        v-model="cards"
        @end="onDragEnd"
        @start="onStart"
      >
        <v-list-item
          v-for="card in cards"
          :key="card.id"
          class="draggable"
          :disabled="shouldDisableChanges"
        >
          <v-list-item-action>
            <v-row>
              <StIcon
                :disabled="shouldDisableChanges"
                icon-name="drag"
              />
              <v-checkbox
                v-model="card.visible"
                v-ripple
                :disabled="shouldDisableChanges"
                @change="saveCardVisibility(card.visible)"
              />
            </v-row>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ card.props.title ? card.props.title : $t('components.AnnotationTextCard.insert') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </draggable>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { MUTATE } from '@/store/modules/mutation_types';
import draggable from 'vuedraggable';
import StIcon from '@stilingue/st-icon';
import cardsModel from '@/mixins/cards-model';
import { trackEventWithUserProperties } from '@/utils/mixpanel';

export default {
  name: 'ChooseCardMenu',
  components: {
    draggable,
    StIcon,
  },
  mixins: [
    cardsModel,
  ],
  data() {
    return {
      listTitle: 'Componentes',
      grabClassName: 'grabbing',
    };
  },
  computed: {
    ...mapState('misc', [
      'drawer',
    ]),
    miscDrawer: {
      get() {
        return this.drawer;
      },
      set(newValue) {
        this.mutateMisc({
          property: 'drawer',
          with: newValue,
        });
      },
    },
    htmlTag() {
      return document.getElementsByTagName('html').item(0);
    },
  },
  watch: {
    drawer() {
      const html = document.getElementsByTagName('html')[0];
      if (this.drawer) {
        html.classList.add('overflow-hidden');
        return true;
      }
      html.classList.remove('overflow-hidden');
    },
  },
  methods: {
    ...mapMutations('misc', {
      mutateMisc: MUTATE,
    }),
    onDragEnd() {
      this.htmlTag.classList.remove(this.grabClassName);

      trackEventWithUserProperties('ST CardList Card Edit');
    },
    onStart() {
      this.htmlTag.classList.add(this.grabClassName);
    },
    saveCardVisibility(visibility) {
      this.saveCards();

      trackEventWithUserProperties('ST CardList Card On/Off', { On: visibility });
    },
  },
};
</script>

<style scoped lang="scss">
  .theme--dark h3 {
    color: white;
  }

  .draggable {
    cursor: grab;
  }

  [draggable="true"] {
    opacity: 0.5;
    background: gray;
  }

  .v-navigation-drawer--temporary {
    z-index: 999 !important;
  }
</style>
